import { PackageListType } from 'types';

import { get } from './axios';

const URL = {
  getPackages: 'get-cl-packages-v2',
  getPackageItems: 'get-cl-package-items',
  getPackagesByLocationId: 'get-packages-v2',
  getPackagesPromo: 'packages-active-promo'
};

const packagesApi = {
  getPackages: (listType: PackageListType) =>
    get(URL.getPackages, { 'list-type': listType }),
  getPackageItems: (packageId: number) =>
    get(URL.getPackageItems, { package_id: packageId }),
  getPackagesByLocId: (params: { locid: number; pkg_label_id?: number }) =>
    get(URL.getPackagesByLocationId, params),
  getPackagesPromo: () => get(URL.getPackagesPromo)
};

export default packagesApi;
